
import React, { useState } from 'react';
import { Form, Button, Image, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../Customize_Css/Login.css';
import kravezLogo from '../Images/KravezLogoHeader.png';
import user from '../Icons/user.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const Login = () => {
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8000';
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('tenant');
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLoginClick = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await fetch(`${BASE_URL}/login/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          identifier,
          password,
          role,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        const { epicx_tenantId, token, role: userRole, employeeId } = data;
        console.log("Login successful:", data);
        localStorage.setItem('epicxTenantId', epicx_tenantId);
        localStorage.setItem('token', token);
        localStorage.setItem('role', userRole);
        if (userRole === 'employee' && employeeId) {
          localStorage.setItem('employeeId', employeeId);
        }
        // Redirect based on user role: employees go to /view-orders, tenants go to /dashboard
        if (userRole === 'employee') {
          navigate('/view-orders', { state: { epicx_tenantId, role: userRole } });
        } else {
          navigate('/dashboard', { state: { epicx_tenantId, role: userRole } });
        }
      } else {
        console.error("Login failed:", data.message);
        setError(data.message);
      }
    } catch (error) {
      console.error("Error during login:", error);
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <main className="login-screen">
      <section className="login-brand">
        <img className="login-kravez-logo" src={kravezLogo} alt="Kravez" />
        <div className="login-brand-copy">
          <h1>Orders, vendors, and deliveries in one place.</h1>
          <p>Sign in as a tenant or an employee to continue.</p>
        </div>
        <ul className="login-points">
          <li>
            <span>01</span>
            <div>
              <strong>Orders</strong>
              <p>Move each order from placed to delivered.</p>
            </div>
          </li>
          <li>
            <span>02</span>
            <div>
              <strong>Vendors</strong>
              <p>Keep product and delivery partners together.</p>
            </div>
          </li>
          <li>
            <span>03</span>
            <div>
              <strong>Team</strong>
              <p>Tenants open the dashboard. Employees open orders.</p>
            </div>
          </li>
        </ul>
      </section>

      <section className="login-panel">
        <div className="login-card">
          <div className="login-card-head">
            <span className="login-avatar" aria-hidden="true">
              <Image src={user} alt="" />
            </span>
            <div>
              <p className="login-kicker">Welcome back</p>
              <h2>Login to account</h2>
            </div>
          </div>

          {error && <Alert variant="danger" className="login-error">{error}</Alert>}

          <Form onSubmit={handleLoginClick}>
            <Form.Group className="login-field" controlId="role">
              <Form.Label>Role <span className="login-required">*</span></Form.Label>
              <div className="login-roles" role="radiogroup" aria-label="Role">
                <button
                  type="button"
                  role="radio"
                  aria-checked={role === 'tenant'}
                  className={role === 'tenant' ? 'is-active' : ''}
                  onClick={() => setRole('tenant')}
                >
                  Tenant
                </button>
                <button
                  type="button"
                  role="radio"
                  aria-checked={role === 'employee'}
                  className={role === 'employee' ? 'is-active' : ''}
                  onClick={() => setRole('employee')}
                >
                  Employee
                </button>
              </div>
            </Form.Group>

            <Form.Group className="login-field" controlId="identifier">
              <Form.Label>Login Identifier <span className="login-required">*</span></Form.Label>
              <Form.Control
                type="text"
                placeholder="Email, phone, or username"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                autoComplete="username"
              />
            </Form.Group>

            <Form.Group className="login-field" controlId="password">
              <Form.Label>Password <span className="login-required">*</span></Form.Label>
              <div className="login-password">
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="login-eye"
                  onClick={togglePasswordVisibility}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
              <a href="#" className="forgot-password" onClick={(e) => { e.preventDefault(); navigate('/forgot-password', { state: { role } }); }}>Forgot password?</a>
            </Form.Group>

            <Button id="login-button" type="submit">
              Log in
            </Button>
          </Form>
        </div>
      </section>
    </main>
  );
};

export default Login;

// import React, { useState } from 'react';
// import { Container, Row, Col, Form, Button, Image, Alert } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';
// import '../Customize_Css/Login.css';
// import logo from '../Icons/icon.png';
// import user from '../Icons/user.svg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

// const Login = () => {
//   const navigate = useNavigate();
//   const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8000';
//   const [identifier, setIdentifier] = useState('');
//   const [password, setPassword] = useState('');
//   const [role, setRole] = useState('tenant');
//   const [error, setError] = useState(null);
//   const [showPassword, setShowPassword] = useState(false);

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   const handleLoginClick = async (e) => {
//     e.preventDefault();
//     setError(null);

//     try {
//       const response = await fetch(`${BASE_URL}/login/api/login`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           identifier,
//           password,
//           role
//         }),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         const { epicx_tenantId, token, role: userRole } = data;
//         console.log("Login successful:", data);
//         localStorage.setItem('epicxTenantId', epicx_tenantId);
//         localStorage.setItem('token', token);
//         localStorage.setItem('role', userRole);
//         navigate('/dashboard', { state: { epicx_tenantId, role: userRole } });
//       } else {
//         console.error("Login failed:", data.message);
//         setError(data.message);
//       }
//     } catch (error) {
//       console.error("Error during login:", error);
//       setError("An error occurred. Please try again.");
//     }
//   };

//   return (
//     <Container fluid className="login-container">
//       <Row className="justify-content-center align-items-center vh-100">
//         <Col md={4}>
//           <div className="login-box">
//             <div className="login-header text-center">
//               <div className="image-circle" style={{ marginLeft: '45%', marginTop: '-13%' }}>
//                 <Image src={user} alt="Fresh Delish" className="logo mb-3" />
//               </div>
//               <div className="image-text-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
//                 <img src={logo} alt="Fresh Delish" className="small-logo" style={{ marginRight: '10px' }} />
//                 <span style={{ color: '#1EA073', fontWeight: 'bold', fontSize: '20px' }}>FRESH DELISH</span>
//               </div>
//               <h2>LOGIN TO ACCOUNT</h2>
//               <p>Please select your role and enter your credentials to continue...</p>
//             </div>
//             {error && <Alert variant="danger">{error}</Alert>}
//             <Form onSubmit={handleLoginClick}>
//               <Form.Group className="mb-3" controlId="role">
//                 <Form.Label>Role</Form.Label>
//                 <span style={{ color: 'red' }}>*</span>
//                 <Form.Select value={role} onChange={(e) => setRole(e.target.value)}>
//                   <option value="tenant">Tenant</option>
//                   <option value="employee">Employee</option>
//                 </Form.Select>
//               </Form.Group>
//               <Form.Group className="mb-3" controlId="identifier">
//                 <Form.Label>Login Identifier</Form.Label>
//                 <span style={{ color: 'red' }}>*</span>
//                 <Form.Control
//                   type="text"
//                   placeholder="Enter your email, phone, or username"
//                   value={identifier}
//                   onChange={(e) => setIdentifier(e.target.value)}
//                 />
//               </Form.Group>
//               <Form.Group className="mb-3" controlId="password">
//                 <Form.Label>Password</Form.Label>
//                 <span style={{ color: 'red' }}>*</span>
//                 <div className="password-input-container" style={{ position: 'relative' }}>
//                   <Form.Control
//                     type={showPassword ? 'text' : 'password'}
//                     placeholder="Enter your secret password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                   />
//                   <span
//                     onClick={togglePasswordVisibility}
//                     style={{
//                       position: 'absolute',
//                       right: '10px',
//                       top: '50%',
//                       transform: 'translateY(-50%)',
//                       cursor: 'pointer',
//                     }}
//                   >
//                     <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
//                   </span>
//                 </div>
//                 <Form.Text className="text-end d-block">
//                   <a href="/forgot-password" className="forgot-password">Forgot Password?</a>
//                 </Form.Text>
//               </Form.Group>
//               {/* <Form.Group className="mb-3" controlId="remember">
//                 <Form.Check type="checkbox" label="Remember Password" />
//               </Form.Group> */}
//               <Button id="login-button" type="submit" className="w-100">
//                 LOG IN
//               </Button>
//             </Form>
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default Login;
